import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { ItemPurchaseCreateForm } from '@/features/item/components/item-purchase-form'

export const Route = createFileRoute('/_app/inventory/po/create')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/master', 'Master Bahan'],
				]}
			/>
			<PageCard>
				<PageCard.Header title="Buat Pesanan" />
				<ItemPurchaseCreateForm />
			</PageCard>
		</PageLayout.Root>
	)
}
